import { Injectable } from '@angular/core';
import { RequestService } from '../requestService/request.service';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private requestService: RequestService) { }

  // Search API
  search(params) {
    let req = {
      url: "/api/pages/search",
      req: {
        offset: params.offset,
        count: params.count,
        key: params.key
      }
    };
    return new Promise(resolve => {
      this.requestService.mainPostRequest(req).then((resp:any) => {
        resolve({
          assets: resp.data.assets,
          nextPage: resp.data.nextPage
        });
      });
    });
  }
}
